import { graphql } from "@/gql";

export const tripRoutesQuery = graphql(`
  query TripRoutes($id: ID!) {
    tripRoutes(id: $id) {
      name
      polyline
      distance_kms
      duration_seconds
      image_url
    }
  }
`);
